import React, { Component } from 'react';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';
import InputBase from '@material-ui/core/InputBase';

import {
  Container, EditButton, EditIcon, Text, TextContainer, style, TextAlignementContainer,
} from './style';

// ToDo -> move this component to reusable components folder
class EditInput extends Component {
  state = {
    active: false,
    hover : false,
  };

  inputRef = React.createRef();

  onClick = () => {
    this.setState({ active: true }, () => {
      this.inputRef.current.focus();
    });
  };

  onInputBlur = (event) => {
    const { onChange } = this.props;
    onChange(event.target.value);
    this.setState({ active: false, hover: false });
  };

  onMouseEnter = () => {
    this.setState({ hover: true });
  };

  onMouseLeave = () => {
    this.setState({ hover: false });
  };

  render() {
    const {
      children,
      classes,
      fullWidth,
      multiline,
      rows,
      rowsMax,
      value,
    } = this.props;
    const { active, hover } = this.state;

    return (
      <Container>
        {active ? (
          <InputBase
            classes={
              {
                input    : classes.input,
                multiline: classes.multiline,
              }
            }
            defaultValue={value}
            fullWidth={fullWidth}
            inputRef={this.inputRef}
            multiline={multiline}
            onBlur={this.onInputBlur}
            rows={rows}
            rowsMax={rowsMax}
          />
        ) : (
          <TextContainer onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
            <TextAlignementContainer onClick={this.onClick}>
              <Text>{children}</Text>
              {hover && (
                <EditButton>
                  <EditIcon />
                </EditButton>
              )}
            </TextAlignementContainer>
          </TextContainer>
        )}
      </Container>
    );
  }
}
EditInput.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  classes: PropTypes.shape({
    input    : PropTypes.string,
    multiline: PropTypes.string,
  }).isRequired,
  fullWidth: PropTypes.bool,
  multiline: PropTypes.bool,
  onChange : PropTypes.func,
  rows     : PropTypes.number,
  rowsMax  : PropTypes.number,
  value    : PropTypes.string,

};
EditInput.defaultProps = {
  children : null,
  fullWidth: false,
  multiline: false,
  onChange() {},
  rows     : null,
  rowsMax  : null,
  value    : null,
};

export default withStyles(style)(EditInput);
